<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __ReportsPage, {ReportsPage as _ReportsPage, loadData} from '@/pages/account/ReportsPage.vue'

    // Reports the customer asked to hide on the ZSH reports page.
    // Keys match the result of getCategoryTranslationKey(report.reportName).
    const HIDDEN_REPORT_KEYS = new Set([
        'emails_sent_report',
        'email_sent_report',
        'hotel_production_report_by_supplier',
        'look_to_book',
        'look_to_book_by_agencies_distributors',
        'look_to_book_by_corporate_clients',
        'look_to_book_by_countries',
        'look_to_book_by_products',
        'summary_report_for_accommodation',
        'turnovers_by_agencies_distributors',
        'turnovers_by_cities',
        'turnovers_by_corporate_clients',
        'turnovers_by_countries',
        'turnovers_by_products',
        'turnovers_by_sales_channels',
        'turnovers_by_users',
        'turnovers_by_web_sites',
        'user_login_report',
        'supplier_invoices',
        'hotels_availability_report',
        'hotels_tariffs_report',
        'price_list_hotels',
        'rooming_list_hotels',
    ])

    @Component({
        mixins: [__ReportsPage],
        async setup() {
            const app = useNuxtApp()
            const $api = app.$api
            const {data} = await useAsyncData('reports', async () => {
                try {
                    const res = await loadData($api)
                    return res.categories ? res.categories : []
                } catch (e) {
                    return []
                }
            })

            return {categories: data.value}
        },
    })
    export class ReportsPage extends _ReportsPage {
        get categoriesToShow() {
            return this.categories
                .map(category =>
                    category.filter(report => !HIDDEN_REPORT_KEYS.has(this.getCategoryTranslationKey(report.reportName)))
                )
                .filter(category => category.length > 0)
        }
    }

    export default {...toNative(ReportsPage), ssrRender: __ReportsPage.ssrRender}
</script>
